// This file gets environment variables with guards in case they are not set

const getProcessEnv = (key: string): string | undefined => {
  try {
    return process.env[key];
  } catch {
    // continue
  }

  return undefined;
};

const getNodeEnv = (): 'development' | 'test' | 'production' | undefined => {
  try {
    if (process.env.NODE_ENV) {
      if (
        ['development', 'test', 'production'].includes(process.env.NODE_ENV)
      ) {
        return process.env.NODE_ENV as 'development' | 'test' | 'production';
      } else {
        console.error('NODE_ENV is set to an unrecognized value.');
      }
    }
  } catch {
    // continue
  }

  // For non-appshell projects
  try {
    if (window.location.hostname.indexOf('.autodesk.') >= 0) {
      return 'production';
    }
  } catch {
    // continue
  }

  return undefined;
};

const REACT_APP_SEGMENT_API_KEY: string | undefined = getProcessEnv(
  'REACT_APP_SEGMENT_API_KEY',
);
const REACT_APP_DISABLE_SEGMENT: string | undefined = getProcessEnv(
  'REACT_APP_DISABLE_SEGMENT',
);
const NODE_ENV: 'development' | 'test' | 'production' | undefined =
  getNodeEnv();

export { REACT_APP_SEGMENT_API_KEY, REACT_APP_DISABLE_SEGMENT, NODE_ENV };
